import { allowedTypes, MAX_SIZE } from "@utils/file";
import { formatFileName } from "@utils/format";

export type AttachmentFileMessages = {
  tooLarge: string;
  invalidType: string;
};

export type AttachmentFileHandlers = {
  setError: (message: string) => void;
  changeFileName: (fileName: string) => void;
  onFile?: (file: File) => void;
};

export const validateAttachmentFile = (file: File | null, messages: AttachmentFileMessages): string => {
  if (!file) return "";

  if (file.size > MAX_SIZE) {
    return messages.tooLarge;
  }

  if (!allowedTypes.includes(file.type)) {
    return messages.invalidType;
  }

  return "";
};

export const processAttachmentFileChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  messages: AttachmentFileMessages,
  handlers: AttachmentFileHandlers
) => {
  const file = event.target.files?.[0] ?? null;
  const name = formatFileName(file?.name);
  const validation = validateAttachmentFile(file, messages);

  if (validation) {
    handlers.setError(validation);
    handlers.changeFileName("");
    return;
  }

  if (file) {
    handlers.setError("");
    handlers.changeFileName(name);
    const renamedFile = new File([file], name, { type: file.type, lastModified: file.lastModified });
    handlers.onFile?.(renamedFile);
  }
};
